import { type ISettingsRepository } from '@webapp/core/business-logic/interfaces/ISettingsRepository'
import { throwRepoErrorFromApiV3Error } from '@webapp/core/utils/repositories/throwRepoErrorFromApiV3Error'
import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { type IntegrationStatusConstructor } from '@webapp/platform/integrations'
import { mapIntegrationStatus } from '../../mappers/mapIntegrationStatus'
import type { GetIntegrationStatusResponse } from '../../types/GetIntegrationStatusResponse'

const BASE_URL = '/api/v3/settings'

interface Dependency {
  httpClient: IHttpClient
}

export class SettingsRepository implements ISettingsRepository {
  constructor(private readonly deps: Dependency) {}

  async getIntegrationStatus(): Promise<IntegrationStatusConstructor> {
    try {
      const res = await this.deps.httpClient.get<GetIntegrationStatusResponse>(
        `${BASE_URL}/integration-status/`
      )
      return mapIntegrationStatus(res.data.data)
    } catch (err) {
      throw throwRepoErrorFromApiV3Error(err)
    }
  }
}
